var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-insta {\n        stroke-width: 4.27px;\n      }\n\n      .cls-insta, .cls-insta2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-insta2 {\n        stroke-width: 5.69px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_5",
    "data-name": "Rect\\xE1ngulo 5",
    className: "cls-insta2",
    x: 5.16,
    y: 5.16,
    width: 100.23,
    height: 100.23,
    rx: 16.17,
    ry: 16.17
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    className: "cls-insta",
    cx: 55.27,
    cy: 55.27,
    r: 27.49
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    className: "cls-insta",
    cx: 85.99,
    cy: 24.56,
    r: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    className: "cls-insta",
    d: "M66.5,39.47c-8.67-6.26-20.76-4.31-27.02,4.36-4.89,6.77-4.89,15.9,0,22.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    className: "cls-insta",
    d: "M44.05,71.07c8.67,6.26,20.76,4.31,27.02-4.36,4.89-6.77,4.89-15.9,0-22.67"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramTop);
export default __webpack_public_path__ + "static/media/instagram-top.8b976e64aa04ee25da31d3bc6cab7123.svg";
export { ForwardRef as ReactComponent };